module.exports = __webpack_public_path__ + "static/media/StandardChartered-logo.0e5d732a.png";